import { render, staticRenderFns } from "./DialogDetallePago.vue?vue&type=template&id=7f6e1208&"
import script from "./DialogDetallePago.vue?vue&type=script&lang=js&"
export * from "./DialogDetallePago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports